// extracted by mini-css-extract-plugin
module.exports = {"container":"OfficeInfoCard-module__container___V9VCo","item":"OfficeInfoCard-module__item___20xEj"};